module.exports = __webpack_public_path__ + "-/media/Project/Hyland/Common/images/solution-builder/img/solution-configurator-page-3-industries-02.svg";